var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63636 21.0045H5.45455V11.7318L0 7.64087V19.3681C0 20.2736 0.733636 21.0045 1.63636 21.0045Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5454 21.0045H22.3636C23.269 21.0045 24 20.2709 24 19.3681V7.64087L18.5454 11.7318",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5454 4.64101V11.7319L24 7.64101V5.45919C24 3.43555 21.69 2.28191 20.0727 3.49555",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45459 11.7318V4.64087L12 9.54996L18.5455 4.64087V11.7318L12 16.6409",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.45919V7.64101L5.45455 11.7319V4.64101L3.92727 3.49555C2.30727 2.28191 0 3.43555 0 5.45919Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.f900e4889f8cd1bd137cdcf929983090.svg";
export { ForwardRef as ReactComponent };